import React from "react";

// Material UI
import HighlightIcon from "@material-ui/icons/Highlight";

export default function Header() {
  return (
    <header>
      <h1>
        <HighlightIcon /> Keeper
      </h1>
    </header>
  );
}
